import { createContext, useContext } from 'react'
import type { User } from '../api/types'
import type { TelegramWidgetUser } from '../telegram'

export type AuthErrorKind = 'network' | 'expired' | 'bad_signature' | 'session' | 'unknown'

export type AuthState =
  | { status: 'loading' }
  | { status: 'signed_out' }
  | { status: 'signed_in'; user: User }
  | { status: 'no_access'; hadInvite: boolean }
  | { status: 'error'; kind: AuthErrorKind }

export interface AuthContextValue {
  state: AuthState
  /** Возвращают текст ошибки для формы входа или null. 403 переводит в состояние no_access. */
  signInWithWidget(user: TelegramWidgetUser): Promise<string | null>
  signInWithDev(telegramId: number): Promise<string | null>
  signOut(): void
  retry(): void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth вне AuthProvider')
  return ctx
}

/** Текущий пользователь. Только внутри экранов, которые видны после входа. */
export function useUser(): User {
  const { state } = useAuth()
  if (state.status !== 'signed_in') throw new Error('useUser до входа')
  return state.user
}
